import changeOrder from "./sortOrder";
// import authReducer from "./authReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    // authReducer,
    changeOrder
})

export default rootReducer;